import { render } from "./OrdersRow.vue?vue&type=template&id=9c437c8e"
import script from "./OrdersRow.vue?vue&type=script&lang=js"
export * from "./OrdersRow.vue?vue&type=script&lang=js"

import "./OrdersRow.vue?vue&type=style&index=0&id=9c437c8e&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__